import React from "react";
import styles from "./styles.module.css";

export default function Toggle({ value, onChange }) {
  return (
    <div className={styles.toggle}>
      <div
        className={
          value === "pages"
            ? `${styles.toggleHighlight} ${styles.left}`
            : `${styles.toggleHighlight} ${styles.right}`
        }
      ></div>
      <div onClick={() => onChange("pages")} className={styles.toggleButton}>
        Pages
      </div>
      <div
        onClick={() => onChange("components")}
        className={styles.toggleButton}
      >
        Components
      </div>
    </div>
  );
}
